import queryKeys from "./queryKeys"
import { useInjection } from "@murphy-frontend/common/contexts/InversifyContext"
import ApiServiceType, { IApiService } from "@murphy-frontend/common/interfaces/IApiService"
import { RequirementApi } from "./RequirementApi"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import {
	UpdateBlockActionPointRequest,
	UpdateBlockStatusesRequest,
	UpdateCustomerGoalLevelRequest,
	CreateBlockActionPointRequest,
	UpdateBlockActionPointResponseRequest,
	DeleteBlockActionPointRequest,
	CreateBlockNoteRequest,
	DeleteBlockNoteRequest,
	UpdateBlockNoteRequest
} from "./models"
import { toast } from "react-toastify"
import { UpdateRoadmapItemRequest } from "./models";

export function useUpdateCustomerBlockStatuses() {
	const queryClient = useQueryClient()
	const apiService = useInjection<IApiService>(ApiServiceType.IApiService)
	const requirementApi = new RequirementApi(apiService)

	return useMutation({
		mutationFn: (updateRequest: UpdateBlockStatusesRequest) =>
			requirementApi.updateCustomerRequirementBlockStatus(updateRequest),
		onError: (err: any) => {
			if (err.response && err.response.data) {
				toast.error(err.response.data)
			} else {
				toast.error("Error")
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.customerBlocks(variables.CustomerId) })
			toast.success("Success")
		}
	})
}

export function useUpdateRequirementBlockActionPointResponse() {
	const queryClient = useQueryClient()
	const apiService = useInjection<IApiService>(ApiServiceType.IApiService)
	const requirementApi = new RequirementApi(apiService)

	return useMutation({
		mutationFn: (updateRequest: UpdateBlockActionPointResponseRequest) =>
			requirementApi.updateRequirementBlockActionPointResponse(updateRequest),
		onError: (err: any) => {
			if (err.response && err.response.data) {
				toast.error(err.response.data)
			} else {
				toast.error("Error")
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.customerBlocks(variables.CustomerId) })
			toast.success("Success")
		}
	})
}
export function useDeleteCustomerBlockActionPoint() {
	const queryClient = useQueryClient()
	const apiService = useInjection<IApiService>(ApiServiceType.IApiService)
	const requirementApi = new RequirementApi(apiService)

	return useMutation({
		mutationFn: (updateRequest: DeleteBlockActionPointRequest) =>
			requirementApi.deleteCustomerRequirementBlockActionPoint(updateRequest),
		onError: (err: any) => {
			if (err.response && err.response.data) {
				toast.error(err.response.data)
			} else {
				toast.error("Error")
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.customerBlocks(variables.CustomerId) })
			toast.success("Success")
		}
	})
}

export function useUpdateCustomerBlockActionPoint() {
	const queryClient = useQueryClient()
	const apiService = useInjection<IApiService>(ApiServiceType.IApiService)
	const requirementApi = new RequirementApi(apiService)

	return useMutation({
		mutationFn: (updateRequest: UpdateBlockActionPointRequest) =>
			requirementApi.updateCustomerRequirementBlockActionPoint(updateRequest),
		onError: (err: any) => {
			if (err.response && err.response.data) {
				toast.error(err.response.data)
			} else {
				toast.error("Error")
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.customerBlocks(variables.CustomerId) })
			toast.success("Success")
		}
	})
}

export function useCreateCustomerBlockActionPoint() {
	const queryClient = useQueryClient()
	const apiService = useInjection<IApiService>(ApiServiceType.IApiService)
	const requirementApi = new RequirementApi(apiService)

	return useMutation({
		mutationFn: (updateRequest: CreateBlockActionPointRequest) =>
			requirementApi.createCustomerRequirementBlockActionPoint(updateRequest),
		onError: (err: any) => {
			if (err.response && err.response.data) {
				toast.error(err.response.data)
			} else {
				toast.error("Error")
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.customerBlocks(variables.CustomerId) })
			toast.success("Success")
		}
	})
}

export function useUpdateCustomerGoalLevel() {
	const queryClient = useQueryClient()
	const apiService = useInjection<IApiService>(ApiServiceType.IApiService)
	const requirementApi = new RequirementApi(apiService)

	return useMutation({
		mutationFn: (updateRequest: UpdateCustomerGoalLevelRequest) =>
			requirementApi.updateCustomerGoalLevel(updateRequest),
		onError: (err: any) => {
			if (err.response && err.response.data) {
				toast.error(err.response.data)
			} else {
				toast.error("Error")
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.requirementLevels(variables.CustomerId) })
			toast.success("Success")
		}
	})
}

export function useCreateCustomerBlockNote() {
	const queryClient = useQueryClient()
	const apiService = useInjection<IApiService>(ApiServiceType.IApiService)
	const requirementApi = new RequirementApi(apiService)

	return useMutation({
		mutationFn: (updateRequest: CreateBlockNoteRequest) =>
			requirementApi.createCustomerRequirementBlockNote(updateRequest),
		onError: (err: any) => {
			if (err.response && err.response.data) {
				toast.error(err.response.data)
			} else {
				toast.error("Error")
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.customerBlocks(variables.CustomerId) })
			toast.success("Success")
		}
	})
}

export function useUpdateCustomerRequirementBlockNote() {
	const queryClient = useQueryClient()
	const apiService = useInjection<IApiService>(ApiServiceType.IApiService)
	const requirementApi = new RequirementApi(apiService)

	return useMutation({
		mutationFn: (updateRequest: UpdateBlockNoteRequest) =>
			requirementApi.updateCustomerRequirementBlockNote(updateRequest),
		onError: (err: any) => {
			if (err.response && err.response.data) {
				toast.error(err.response.data)
			} else {
				toast.error("Error")
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.customerBlocks(variables.CustomerId) })
			toast.success("Success")
		}
	})
}

export function useDeleteCustomerRequirementBlockNote() {
	const queryClient = useQueryClient()
	const apiService = useInjection<IApiService>(ApiServiceType.IApiService)
	const requirementApi = new RequirementApi(apiService)

	return useMutation({
		mutationFn: (deleteRequest: DeleteBlockNoteRequest) =>
			requirementApi.deleteCustomerRequirementBlockNote(deleteRequest),
		onError: (err: any) => {
			if (err.response && err.response.data) {
				toast.error(err.response.data)
			} else {
				toast.error("Error")
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.customerBlocks(variables.CustomerId) })
			toast.success("Success")
		}
	})
}

export function useUpdateRoadmapItem(customerId: string) {
	const apiService = useInjection<IApiService>(ApiServiceType.IApiService);
	const requirementApi = new RequirementApi(apiService);
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ roadmapItemId, updateRequest }: { roadmapItemId: number; updateRequest: UpdateRoadmapItemRequest }) =>
			requirementApi.updateRoadmapItem(customerId, roadmapItemId, updateRequest),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.roadmap(customerId) });
		},
	});
}